﻿import { Box, Typography } from '@atgfr8/atg-ui-tailwind';
import { Component, JSXElement } from 'solid-js';

export type PageHeaderProps = {
  title: string;
  children?: JSXElement[] | JSXElement;
};

export const PageHeader: Component<PageHeaderProps> = (
  props: PageHeaderProps,
) => {
  return (
    <Box
      backgroundColor="white"
      class="flex items-center gap-5 h-fit bg-white sticky shadow-lg flex-wrap p-2"
    >
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        class="flex space-x-2 justify-start pl-6 flex-wrap"
      >
        <Typography variant="h5" class="truncate">
          {props.title}
        </Typography>
      </Box>
      <Box class="flex-wrap flex justify-end items-center" gap={2}>
        {props.children}
      </Box>
    </Box>
  );
};
